const shadows = {
  textShadows: {
    small: `0 5px 10px rgba(0, 0, 0, 0.25)`,
    big: `0 15px 20px rgba(0, 0, 0, 0.13)`,
  },
}

export type Shadows = typeof shadows

export default shadows
